import { render, staticRenderFns } from "./student-reply-refer-form.vue?vue&type=template&id=5b5f7900&scoped=true&"
import script from "./student-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./student-reply-refer-form.vue?vue&type=script&lang=js&"
import style0 from "./student-reply-refer-form.vue?vue&type=style&index=0&id=5b5f7900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f7900",
  null
  
)

export default component.exports